import { render, staticRenderFns } from "./FrrTicker.vue?vue&type=template&id=12b1d7ec&scoped=true&"
import script from "./FrrTicker.vue?vue&type=script&lang=js&"
export * from "./FrrTicker.vue?vue&type=script&lang=js&"
import style0 from "./FrrTicker.sass?vue&type=style&index=0&id=12b1d7ec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1d7ec",
  null
  
)

export default component.exports